module.exports = __webpack_public_path__ + "media/images/logo-icon-b1d1d444e73beaf8dff81b1c69afa6a6.png";